/**
 * Sentinel values used across the app to represent "not yet fetched" vs
 * "fetched and found to be empty/missing" states for fields on catches and
 * fishing conditions. Straight port of SaltwaterUpModel's defaultPending*
 * and defaultNoData* class methods in the iOS app.
 */
export const Sentinels = {
  pendingId: -1,
  pendingInt: -1,
  pendingDouble: -998.99,
  pendingString: 'UnknownPending',
  pendingDate: '1901-01-01 00:00:00',

  noDataId: 0,
  noDataInt: 0,
  noDataDouble: -999.99,
  noDataString: 'Unknown',
  noDataDate: '1900-01-01 00:00:00',
} as const;

export function isPendingOrNoDataId(id: number): boolean {
  return id === Sentinels.pendingId || id === Sentinels.noDataId;
}

export function isPendingOrNoDataDouble(value: number): boolean {
  return value === Sentinels.pendingDouble || value === Sentinels.noDataDouble;
}
